import { Box, Flex, Image, Text } from '@chakra-ui/react';

import { useEffect, useState } from "react";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "react-datepicker/dist/react-datepicker.css";
import { useNavigate } from 'react-router-dom';
import empty from '../../../img/emptystate2.svg';
import engineering from '../../../img/engring.png';
import { IAllCourse } from '../../../models/allcourse.model';
import trainerRoutes from '../../../pages/trainer/routes';
import trainercoursesService from '../../../services/trainer/trainercourses.service';
import Loading from '../../common/Loading';
import TrDashboardHeader from '../../common/TrainerDashboardHeader';


const MyTrainerCourses = () => {

    // const mountedRef = useRef(true);

    // const courseFormatRef = useRef<HTMLSelectElement>(null)
    const navigate = useNavigate()
    const [assignedCourses, setAssignedCourses] = useState<IAllCourse[] | null>(null);
    const [loading, setLoading] = useState(true);


    useEffect(() => {
        trainercoursesService.getTrainerCourses().then(
            (res) => {
                
                setAssignedCourses(res.data); // this returns all that has been assigned to you even though its not available
                
                setLoading(false)
            }
        )
    }, []);


    return (
        <> {
            loading ? <Loading /> :
                <Box>
                    <TrDashboardHeader />
                    <Box bg='#F9F8F8' minHeight="95vh" height='auto' pb="1.2rem" pt='20px'>
                        <Box bg='white' fontWeight='700' fontSize='20px' px='20px' color='#353535' width={["90%","90%","70%","60%"]} mx='auto' py='10px' mb='20px' mt='50px' boxShadow='base'>My Courses</Box>
                        {
                           assignedCourses && assignedCourses.length > 0 ? assignedCourses.map((each, index) =>
                                <Box key={index} bg='white' width={["90%","90%","70%","60%"]} mb="1rem" mx='auto' pt='10px' pb='20px' boxShadow='base' onClick={() => navigate(trainerRoutes.trainerCourses.CourseInformationLink(each.uuid))} cursor='pointer'>
                                    <Box p='8px' bg='white' mb='25px'>
                                        <Flex mx='auto' width='87%' bg='white' pb='8px' pt='10px' mb='24px' borderBottom='2px solid' borderColor='gray.200' justifyContent='space-between'>
                                            <Text fontSize='18px' fontWeight='600'>Lecture </Text>
                                        </Flex>
                                        <Flex flexDirection={{lg:'row', md:'column', sm:'column', base:'column'}} mx='auto' width='87%' bg='white' pb='12px' pt='15px' justifyContent='space-between'>
                                            <Box  width={{lg:'47%', md:'100%', sm:'100%', base:'100%'}}>
                                                {each.cover_image ? <Image objectFit='cover' objectPosition='center' width='100%' height='200px' src={each.cover_image} /> : <Image objectFit='cover' height='200px' objectPosition='center' width='100%' src={engineering} />}
                                            </Box>
                                            <Box width={{lg:'47%', md:'100%', sm:'100%', base:'100%'}}>
                                                <Text color='black' fontSize={{lg:'22px',md:'20px', sm:'16px', base:'16px'}} fontWeight='600' mb='21px'>{each.name}</Text>
                                                <Text color='#9E9E9E' fontSize={{lg:'14px',md:'13px', sm:'12px', base:'12px'}} fontWeight='400' mb='21px'>
                                                    {each.description ? each.description.slice(0, 200) : 'Nil'}
                                                </Text>
                                            </Box>
                                        </Flex>
                                    </Box>

                                </Box>

                            ) :
                                <Flex mx='auto' width={["90%","90%","70%","60%"]} bg='white' pb='12px' pt='15px' justifyContent='center' >
                                    <Box pb="1.4rem">
                                        <Box mx='auto' width={'70px'} height='100px' >
                                            <Image src={empty} />
                                        </Box>
                                        <Text textAlign='center' fontWeight='600' fontSize='30px' color='#353535'>No Courses</Text>
                                        <Text color='#353535' textAlign='center' fontSize='14px'>Courses Assigned to you will be seen here.</Text>
                                    </Box>

                                </Flex>
                        }
                    </Box>

                </Box>


        }
        </>
    )
}

export default MyTrainerCourses;